function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_style") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "5.902 27.201 3.656 2 28.344 2 26.095 27.197 15.985 30 5.902 27.201",
    style: {
      fill: "#1572b6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16 27.858 24.17 25.593 26.092 4.061 16 4.061 16 27.858",
    style: {
      fill: "#33a9dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.347,14.714c2.254,0,2.572-.913,2.572-1.734a10.229,10.229,0,0,0-.256-1.966,10.236,10.236,0,0,1-.253-1.945C9.409,6.913,11.314,6,14.013,6h.667V7.289h-.571c-1.874,0-2.507.749-2.507,2.014a7.538,7.538,0,0,0,.222,1.663,8.183,8.183,0,0,1,.222,1.779c.031,1.5-.858,2.248-2.288,2.531v.046a2.4,2.4,0,0,1,2.288,2.554,7.98,7.98,0,0,1-.222,1.779,7.74,7.74,0,0,0-.222,1.688c0,1.31.729,2.037,2.507,2.037h.571v1.287h-.667c-2.634,0-4.6-.843-4.6-3.208a9.964,9.964,0,0,1,.253-1.92,9.565,9.565,0,0,0,.256-1.9c0-.727-.318-1.734-2.572-1.734Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.68,15.906c-2.254,0-2.572,1.007-2.572,1.733a9.752,9.752,0,0,0,.253,1.9,9.788,9.788,0,0,1,.256,1.92c0,2.365-2,3.209-4.6,3.209h-.667V23.378h.54c1.778-.023,2.538-.727,2.538-2.037a10.532,10.532,0,0,0-.222-1.688,7.96,7.96,0,0,1-.253-1.779,2.445,2.445,0,0,1,2.285-2.553v-.046a2.44,2.44,0,0,1-2.285-2.53,8.189,8.189,0,0,1,.253-1.779A10.266,10.266,0,0,0,20.425,9.3c0-1.264-.667-1.991-2.507-2.014h-.571V6h.636c2.7,0,4.635.913,4.635,3.068a10.035,10.035,0,0,1-.256,1.945,10.43,10.43,0,0,0-.253,1.966c0,.82.318,1.733,2.572,1.733Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.6cd9fcaa7aa7366fbfaada01df5d1f3c.svg";
export { ForwardRef as ReactComponent };